import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconChevronLargeRight"><Path fillRule="evenodd" clipRule="evenodd" d="M9.36681 2.10546C9.72284 1.89377 10.1831 2.01078 10.3948 2.36681L15.5909 11.1057C15.9186 11.6569 15.9186 12.3433 15.5909 12.8945L10.3948 21.6334C10.1831 21.9895 9.72284 22.1065 9.36681 21.8948C9.01078 21.6831 8.89377 21.2228 9.10546 20.8668L14.3016 12.1279C14.3484 12.0491 14.3484 11.9511 14.3016 11.8723L9.10546 3.13342C8.89377 2.77739 9.01078 2.31716 9.36681 2.10546Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeRight;
